/* eslint-disable no-shadow */
import { nextTick, computed } from 'vue';
export const useJumpToFirstError = (component) => {
	const findErrorComponents = (element) => {
		let errorComponents = [];
		element.$children.forEach((child) => {
			if (child.hasError) {
				errorComponents.push(child);
			}
			if (child.$children && child.$children.length) {
				errorComponents = [...errorComponents, ...findErrorComponents(child)];
			}
		});
		return errorComponents;
	};
	const findFirstErrorComponent = (element) => {
		const errorComponents = findErrorComponents(element);
		errorComponents.sort((a, b) => {
			return a.$el.getBoundingClientRect().top - b.$el.getBoundingClientRect().top;
		});
		return errorComponents[0];
	};

	const jumpToFirstError = () => {
		nextTick(() => {
			const firstErrorComponent = findFirstErrorComponent(component.proxy.$vnode.child);
			if (firstErrorComponent) {
				let firstErrorInput = firstErrorComponent.$el.querySelector('input:enabled, textarea');
				if (!firstErrorInput) {
					firstErrorInput = firstErrorComponent.$el.querySelector('button');
				}
				if (firstErrorInput) {
					firstErrorInput.focus();
				}
			}
		});
	};

	const errorComponents = computed(() => findErrorComponents(component.proxy.$vnode.child));
	return {
		jumpToFirstError,
		errorComponents
	};
};
